// extracted by mini-css-extract-plugin
export default {"picBed":"picBed_joZOV"};